export type S05StepStatus = "NOT_STARTED" | "PENDING" | "RUNNING" | "COMPLETE" | "PARTIAL" | "FAILED" | "SKIPPED";

export function mapS05DownloadRunStatus(status: string | null | undefined): S05StepStatus {
  const rawStatus = String(status || "NOT_STARTED").toUpperCase();
  if (rawStatus === "COMPLETE") return "COMPLETE";
  if (rawStatus === "FAILED") return "FAILED";
  if (rawStatus === "SKIPPED") return "SKIPPED";
  if (rawStatus === "RUNNING" || rawStatus === "QUEUED") return "RUNNING";
  return "NOT_STARTED";
}

